import request from './requestPB'
// import request, { PROTO_MODULE } from './requestPB'
import { preFix } from './env'

// 查看岗位类型列表 /job/title/list
export const list = (data) => {
  return request({
    url: `${preFix}/job/title/list`,
    method: 'POST',
    data
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSAdminListJobTitleRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSAdminListJobTitleResponse',
    ERROR_ACTION: 'message',
    // PROTO_MODULE: PROTO_MODULE.AI_SERVICE,
    TOKEN_REQUIRED: false
  })
}

// 获取职位列表 POST /job/list
export const getJobList = (data) => {
  return request({
    url: `${preFix}/job/list`,
    method: 'POST',
    data
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSAdminListJobRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSAdminListJobResponse',
    ERROR_ACTION: 'message',
    // PROTO_MODULE: PROTO_MODULE.AI_SERVICE,
    TOKEN_REQUIRED: false
  })
}

// 查看职位详情 POST /job/detail
export const detail = (data) => {
  return request({
    url: `${preFix}/job/detail`,
    method: 'POST',
    data
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSAdminDetailJobRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSAdminDetailJobResponse',
    ERROR_ACTION: 'message',
    // PROTO_MODULE: PROTO_MODULE.AI_SERVICE,
    TOKEN_REQUIRED: false
  })
}
